var GraphPasteSelectionCommand_1;
import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands, XFlowEdgeCommands, XFlowGroupCommands, XFlowNodeCommands, } from '../constant';
import { Disposable } from '../../common/disposable';
import { LOCAL_STORAGE_KEY } from '../../constants';
import { safeJson } from '../../common/safe-json';
import { GraphMappingHelper } from '../mapping-service';
export var NsGraphPasteSelection;
(function (NsGraphPasteSelection) {
    /** Command: 用于注册named factory */
    NsGraphPasteSelection.command = XFlowGraphCommands.GRAPH_PASTE;
    /** hookName */
    NsGraphPasteSelection.hookKey = 'graphPasteSelection';
})(NsGraphPasteSelection || (NsGraphPasteSelection = {}));
function randomNumber(max, min = 0) {
    return Math.floor(Math.random() * (max - min) + min);
}
let GraphPasteSelectionCommand = GraphPasteSelectionCommand_1 = class GraphPasteSelectionCommand {
    constructor() {
        this.updateNodeCopiedProps = (position, nodeConfig) => {
            let dx = randomNumber(100);
            let dy = randomNumber(100);
            if (position) {
                dx = nodeConfig.x - position.x + randomNumber(30);
                dy = nodeConfig.y - position.y + randomNumber(30);
            }
            // 修改坐标
            nodeConfig.x += dx;
            nodeConfig.y += dy;
            // 删除 id
            nodeConfig.originalId = nodeConfig.id;
            delete nodeConfig.id;
            // 修改label
            nodeConfig.label = nodeConfig.label ? `${nodeConfig.label}_copied` : '';
            nodeConfig.isCollapsed = false;
            return nodeConfig;
        };
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            if (GraphPasteSelectionCommand_1.doing) {
                return this;
            }
            GraphPasteSelectionCommand_1.doing = true;
            const result = yield hooks.graphPasteSelection.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { commandService, position } = handlerArgs;
                const jsonString = window.localStorage.getItem(LOCAL_STORAGE_KEY);
                const plainObject = safeJson(jsonString, {
                    nodes: [],
                    edges: [],
                });
                const { nodes = [], edges = [] } = plainObject;
                const { normalNodes, groupNodes } = this.mappingHelper.getNodesByType(nodes);
                this.mappingHelper.addNodes(nodes);
                // 添加普通节点
                yield Promise.all(normalNodes.map((nodeConfig) => __awaiter(this, void 0, void 0, function* () {
                    const res = yield commandService.executeCommand(XFlowNodeCommands.ADD_NODE.id, {
                        nodeConfig: this.updateNodeCopiedProps(position, nodeConfig),
                    });
                    const context = res.contextProvider();
                    const cmdResult = context.getResult();
                    this.mappingHelper.buildNodeMapping(nodeConfig, cmdResult.nodeConfig);
                })));
                // 处理group
                yield Promise.all(groupNodes.map((group) => __awaiter(this, void 0, void 0, function* () {
                    const groupNodeConfig = this.mappingHelper.buildGroupRelations(group);
                    yield commandService.executeCommand(XFlowGroupCommands.ADD_GROUP.id, {
                        nodeConfig: this.updateNodeCopiedProps(position, groupNodeConfig),
                    });
                })));
                // 处理连线
                yield Promise.all(edges.map(edgeConfig => {
                    const copiedEdgeConfig = this.mappingHelper.createEdgeBetweenNodes(edgeConfig);
                    return commandService.executeCommand(XFlowEdgeCommands.ADD_EDGE.id, {
                        edgeConfig: copiedEdgeConfig,
                    });
                }));
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    window.localStorage.setItem(LOCAL_STORAGE_KEY, null);
                })));
                return { err: null };
            }), runtimeHook);
            ctx.setResult(result);
            GraphPasteSelectionCommand_1.doing = false;
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
/** 防止多次执行 */
GraphPasteSelectionCommand.doing = false;
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphPasteSelectionCommand.prototype, "contextProvider", void 0);
__decorate([
    inject(GraphMappingHelper),
    __metadata("design:type", GraphMappingHelper)
], GraphPasteSelectionCommand.prototype, "mappingHelper", void 0);
GraphPasteSelectionCommand = GraphPasteSelectionCommand_1 = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphPasteSelection.command.id },
    })
    /** 创建节点命令 */
], GraphPasteSelectionCommand);
export { GraphPasteSelectionCommand };
//# sourceMappingURL=graph-paste.js.map